export const defaultEntity = 'cartelle';
export const entities = ['cartelle', 'sgdt'];
export const labels = {
    cartelle: 'Cartelle',
    sgdt: 'SGDT',
};